module.exports = __webpack_public_path__ + "img/new-people-chef-order-pad.be348091.png";